import CustomerLayout from './CustomerLayout';

export default CustomerLayout;
